/** @module csi/view/Attributes */
define([
	"lodash",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/middleware/attributes/attributeKeysService",
	"./ToolbarAttributes"
], function({difference, isEqual}, Action, ActionFactory, {flattenAttributeKeys, getVisibleAttributeKeys}, ToolbarAttributes) {

	/**
	 * Redraw/refresh view to display visible attributes
	 * @param {Controller} ac 
	 */
	function _postActionAttributes(ac) {
		const view = ac.widget;
		const {attributeKeys, hiddenKeys} = ac.actionValue;
		const {
			attributeKeys: oldAttributeKeys,
			hiddenKeys: oldHiddenKeys,
		} = view;

		if (isEqual(attributeKeys, oldAttributeKeys) && isEqual(hiddenKeys, oldHiddenKeys)) {
			return;
		}

		view.setAttributeAndHiddenKeys(attributeKeys, hiddenKeys);

		// determine if new attributes are now visible
		const visibleKeys = flattenAttributeKeys(getVisibleAttributeKeys(attributeKeys, hiddenKeys));
		const oldVisibleKeys = flattenAttributeKeys(getVisibleAttributeKeys(oldAttributeKeys, oldHiddenKeys));

		if (difference(visibleKeys, oldVisibleKeys).length) {
			// if so, then need to refresh to query for any new data
			view.refreshWidget();
		} else {
			// if re-organized or hid some attributes, then just redraw (no need to query again)
			view.redrawSpecs();
		}
	}

	return ActionFactory.declare("attributes", Action, {
		classToolbarPlugin: ToolbarAttributes,
		m_id: "ViewAttributes",
		m_postAction: _postActionAttributes,

		constructor() {
			this.setMaterialIcon("list_alt");
		},

		/**
		 * @override
		 * Disable if there are no attributes in the view
		 */
		hasAccess(ctx) {
			return this.inherited(arguments) && !_.isEmpty(ctx.view.attributeKeys);
		},

		/**
		 * @override
		 * Allow action is view supports custom views
		 */
		validate(ctx) {
			return !ctx.bPrint && ctx.view.supportsCustomViews();
		}
	});
});